import { useQuery } from '@tanstack/react-query';

import { getUserProfileInfo } from '../../apis/profile/my-profile';
import type { ProfileSummaryInfo } from '../../types/profile/shared';

export const useProfileInfo = ({
  userId,
  onSuccess,
  enabled,
  staleTime,
}: {
  userId: string;
  onSuccess?: (data: ProfileSummaryInfo) => void;
  enabled?: boolean;
  staleTime?: number;
}) => {
  return useQuery(
    ['profile-info', userId],
    async () => {
      const result = await getUserProfileInfo(userId);
      return result.data;
    },
    { onSuccess, enabled, staleTime },
  );
};
